export default "__VITE_ASSET__92io7KbQ__"